"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-upload", {
    attrs: {
      multiple: _vm.maxCount > 1,
      "list-type": _vm.listType,
      "file-list": _vm.modelValue,
      accept: _vm.accept,
      "default-file-list": _vm.defaultFileList,
      "custom-request": _vm.customRequest
    },
    on: {
      change: _vm.handleFileChange
    }
  }, [[_vm._t("default", function () {
    return [_vm.listType === "picture-card" ? _c("div", [_c("a-icon", {
      attrs: {
        type: "plus"
      }
    }), _c("div", {
      staticClass: "ant-upload-text"
    }, [_vm._v("点击上传")])], 1) : _c("a-button", {
      attrs: {
        type: "dashed"
      }
    }, [_vm._v(" 点击或拖拽文件上传(" + _vm._s(_vm.modelValue.length) + "/" + _vm._s(_vm.maxCount) + ")"), _c("a-icon", {
      attrs: {
        type: "upload"
      }
    })], 1)];
  })]], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;